import { Injectable } from '@angular/core';
import { NotificationTopicSchemaPartnerSubMaintenanceController } from './NotificationTopicSchemaPartnerSubMaintenanceController';

@Injectable()
export class NotificationTopicSchemaPartnerLogisticOperatorSubMaintenanceController extends NotificationTopicSchemaPartnerSubMaintenanceController {
    
    public getResourceRoot(): string {
        return "NOTIFICATIONTOPICSCHEMAPARTNER.LOGISTICOPERATOR";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/partner/logisticoperator/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}